'use client'

import { IFaqsBlock } from '@/page-builder/fragments/FaqsBlock/types'
import { Accordion } from '@ama-pt/agora-design-system'
import Image from '@/components/atoms/image'
import { motion } from 'framer-motion'
import Heading from '@/components/molecules/Heading'
import BupiLinkButton from '@/components/atoms/linkButton'
import { convertLexicalWithInternalLinks } from '@/lib/lexical'

export default function FaqsBlock({
    title,
    description,
    image,
    faqs,
    ctaButton
}: IFaqsBlock) {
    return (
        <section className="container mx-auto flex flex-col-reverse xl:flex-row items-center justify-between gap-32">
            <div className="flex flex-col md:items-start w-full gap-16 md:gap-[44px]">
                <div className="relative">
                    <Heading title={title} description={description} />
                </div>
                <div className="flex flex-col w-full">
                    {faqs?.map((faq, index) => (
                        <Accordion
                            key={index}
                            title={faq.question}
                            headingTitle={
                                <span className="text-neutral-900 text-m-bold">
                                    {faq.question}
                                </span>
                            }
                        >
                            {faq.answer && (
                                <motion.div
                                    layout
                                    className="flex gap-4 px-8 pt-2 pb-8"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <div
                                        dangerouslySetInnerHTML={{ __html: convertLexicalWithInternalLinks( faq?.answer as any ) }}
                                        className="text-m-regular text-neutral-900 py-8 prose prose-ul:my-0 marker:text-neutral-900"
                                    />
                                </motion.div>
                            )}
                        </Accordion>
                    ))}
                </div>

                {ctaButton?.url && ctaButton?.label && (
                    <BupiLinkButton
                        className="w-auto items-center md:items-start xl:items-start"
                        label={ctaButton?.label}
                        link={ctaButton?.url}
                        target={ctaButton?.target}
                        hasIcon
                        leadingIcon="agora-line-arrow-right-circle"
                    />
                )}
            </div>

            {image?.url && (
                <motion.div
                    layout
                    className="w-full max-w-[488px] flex justify-center xl:justify-end xl:items-start"
                >
                    <motion.div
                        layout
                        className="relative aspect-[488/406] w-full"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, ease: 'easeOut' }}
                    >
                        <Image
                            src={image.url}
                            alt={image.alt || 'Ilustração'}
                            fill
                            className="object-contain"
                            priority
                        />
                    </motion.div>
                </motion.div>
            )}
        </section>
    )
}
